// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_IG9","cls2":"ClaimEvaluationRow-cls2_48k ClaimEvaluationRow-cls1_IG9","pulse":"ClaimEvaluationRow-pulse_bSg"};